/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
// BRAND-SPECIFIC-TODO
import React from 'react';
import dynamic from 'next/dynamic';
import { PropTypes } from 'prop-types';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import ProductsGrid from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductsGrid/views';
import { getAPIConfig, getLocator } from '@tcp/core/src/utils';
import { formatProductsData, getIconPath, spcTitleCase } from '@tcp/core/src/utils/utils';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import InputCheckBox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import FavoriteSkeleton from '@tcp/core/src/components/common/atoms/FavoriteSkeleton';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Image from '@tcp/core/src/components/common/atoms/Image';
import withStyles from '../../../../common/hoc/withStyles';
import FavoritesViewStyle from '../styles/Favorites.style';
import { getNonEmptyFiltersList, getSortsList, getVisibleWishlistItems } from '../Favorites.util';
import SelectWishListDropdown from '../molecules/SelectWishListDropdown/SelectWishListDropdown';
import NoFavoritesFound from '../molecules/NoFavoritesFound/views';
import CustomSelect from '../../../../common/molecules/CustomSelect/views';
import AddList from '../molecules/AddList/views';
import EditList from '../molecules/EditList/views';
import ShareList from '../molecules/ShareList/views';
import CopyLink from '../molecules/CopyLink/views';
import ModalWrapper from '../molecules/ModalWrapper';
import { openWindow } from '../../../../../utils/utils.web';
import LoadedProductsCount from '../../ProductListing/molecules/LoadedProductsCount/views';
import { TCP, SNJ, GYM, PJP } from '../../../../../constants/brands.constants';
import GuestFavoritesMessage from '../molecules/GuestFavoritesMessage/GuestFavoritesMessage';
import {
  FAVORITES_LABELS,
  FavoriteLabels,
  lblFavBrand,
  lblFavCopyLink,
  lblFavCreateNewListHeading,
  lblFavEmail,
  lblFavFacebook,
  lblFavMyFavorites,
  lblFavOosMessage,
  lblFavOosRemove,
  lblFavPjp,
  lblFavShare,
  lblFavShareListHeading,
  lblFavSnj,
  lblFavSubjectDefault,
} from '../labels/Favorites.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblGym,
  lblTcp,
} from '../../../../../utils/labels/globalGeneric.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../utils/labels/globalActions.labels';
import { getLabelsOutOfStockCopy } from '../../ProductListing/container/ProductListing.selectors';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '../../../../../utils/labels/globalCommonBrowseLabels.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '../../../../../utils/labels/globalAccessibility.labels';

const ProductListingFiltersForm = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "product-listing-filters-form" */ '../../ProductListing/molecules/ProductListingFiltersForm'
    ),
  {
    ssr: false,
  }
);

const Recommendations = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "recommendations" */ '@tcp/core/src/components/common/molecules/Recommendations'
  )
);

class FavoritesView extends React.PureComponent {
  currentPopupName;

  favLabels = getLabelFromCopyOrFromTranslation(FAVORITES_LABELS, FavoriteLabels);

  globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  globalActionLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACTIONS_LABELS,
    GlobalActionsLabels
  );

  commmonBrowseLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_COMMON_BROWSE_LABELS,
    globalCommonBrowseLabels
  );

  globalAccessibilityLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACCESSIBILITY_LABELS,
    GlobalAccessibilityLabels
  );

  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      itemToMove: '',
      addListFromMoveOption: false,
      seeSuggestedDictionary: {},
      selectedShareOption: renderLabel(this.favLabels[lblFavShare], lblFavShare),
      isRemoveOOSFavShown: false,
    };
  }

  static getDerivedStateFromProps(props) {
    const { wishlistShareStatus } = props;
    if (wishlistShareStatus === true) {
      return {
        isOpenModal: false,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    const { wishlistShareStatus, setListShareSuccess } = prevProps;
    const { activeWishList, trackPageLoad } = this.props;
    if (wishlistShareStatus === true) {
      setListShareSuccess(false);
    }
    if (activeWishList !== prevProps.activeWishList) {
      const filteredItemsList = this.getFilteredItemsList();
      const customEvents = ['event80'];
      const formattedItem = formatProductsData(filteredItemsList);
      trackPageLoad({
        pageName: 'favorites',
        customEvents,
        pageSection: 'favorites',
        pageSubSection: 'favorites',
        pageType: 'favorites',
        supressedProps: ['eVar97'],
        products: formattedItem,
      });
      this.setFavOOSShownState(false);
    }
  }

  setFavOOSShownState = (value) => {
    this.setState({
      isRemoveOOSFavShown: value,
    });
  };

  onSeeSuggestedItems = (colorProductId, itemId) => {
    const { activeWishListId, onReplaceWishlistItem, setSuggestedColorProductId } = this.props;
    const { seeSuggestedDictionary } = this.state;
    const { navigation } = this.props;

    const recommendationAttributes = {
      variation: 'moduleP',
      navigation,
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.FAVORITES,
      partNumber: colorProductId,
      isHeaderAccordion: true,
      isSuggestedItem: true,
      outOfStockColorProductId: colorProductId,
      onDismissSuggestion: this.onCloseSuggestedModal,
      onReplaceWishlistItem,
      suggestedOOSItemId: itemId,
      activeWishListId,
    };
    const suggestedData = {
      colorProductId,
      attributes: recommendationAttributes,
    };
    const dictionary = { ...seeSuggestedDictionary, [colorProductId]: suggestedData };
    setSuggestedColorProductId(colorProductId);
    this.setState({
      seeSuggestedDictionary: dictionary,
    });
  };

  onCloseSuggestedModal = (colorProductId) => {
    const { seeSuggestedDictionary } = this.state;
    const suggestedData = {
      colorProductId: null,
      attributes: null,
    };
    const dictionary = { ...seeSuggestedDictionary, [colorProductId]: suggestedData };
    this.setState({
      seeSuggestedDictionary: dictionary,
    });
  };

  getSharableLink = () => {
    const { activeWishList, wishlistsSummaries } = this.props;
    const activeWishListId = activeWishList && activeWishList.id;
    const currentWishList =
      wishlistsSummaries &&
      wishlistsSummaries.length > 0 &&
      wishlistsSummaries.filter((wishlist) => {
        return wishlist.id === activeWishListId;
      });
    return currentWishList && currentWishList[0].shareableLink;
  };

  handleFacebookShare = (lbl) => {
    this.setState(
      {
        selectedShareOption: lbl,
      },
      () => {
        this.setState({
          selectedShareOption: renderLabel(this.favLabels[lblFavShare], lblFavShare),
        });
        const shareUrl = this.getSharableLink();
        const { facebookShareURL } = getAPIConfig();
        const url = `${facebookShareURL}${encodeURIComponent(shareUrl)}`;
        openWindow(url);
      }
    );
  };

  shareClickHandler = (value) => {
    if (value === renderLabel(this.favLabels[lblFavEmail], lblFavEmail)) {
      this.handleShareList(renderLabel(this.favLabels[lblFavEmail], lblFavEmail));
    } else if (value === renderLabel(this.favLabels[lblFavCopyLink], lblFavCopyLink)) {
      this.handleCopyLink(renderLabel(this.favLabels[lblFavCopyLink], lblFavCopyLink));
    } else {
      this.handleFacebookShare(renderLabel(this.favLabels[lblFavFacebook], lblFavFacebook));
    }
  };

  getFilteredItemsList = () => {
    const {
      activeWishList,
      filteredId,
      sortId,
      gymSelected,
      tcpSelected,
      snjSelected,
      pjpSelected,
    } = this.props;
    let filteredItemsList =
      !!activeWishList && getVisibleWishlistItems(activeWishList.items, filteredId, sortId);
    if (filteredItemsList) {
      if (gymSelected) {
        filteredItemsList = filteredItemsList.filter((item) => item.itemInfo.brand === GYM);
      } else if (tcpSelected) {
        filteredItemsList = filteredItemsList.filter((item) => item.itemInfo.brand === TCP);
      } else if (snjSelected) {
        filteredItemsList = filteredItemsList.filter((item) => item.itemInfo.brand === SNJ);
      } else if (pjpSelected) {
        filteredItemsList = filteredItemsList.filter((item) => item.itemInfo.brand === PJP);
      }
    }
    return filteredItemsList;
  };

  renderProductList = () => {
    const outOfStockLabels = getLabelsOutOfStockCopy(this.commmonBrowseLabels);
    const labels = { ...this.favLabels, ...this.globalAccessibilityLabels };
    const {
      wishlistsSummaries,
      createNewWishListMoveItem,
      createNewWishList,
      setLastDeletedItemId,
      onQuickViewOpenClick,
      isKeepAliveEnabled,
      activeWishList,
      addToBagEcom,
      errorMessages,
      currencyAttributes,
      isLoggedIn,
      cookieToken,
      isShowPriceRangeKillSwitch,
      showPriceRangeForABTest,
      suggestedProductErrors,
      hasSuggestedProduct,
      isCrossBrandMerchandisingEnabled,
      isInfluencerBadgeEnabled,
      isInfluencerPicksEnabled,
      isGuestFav,
      isGuestFavWeb,
    } = this.props;
    const { seeSuggestedDictionary } = this.state;
    const filteredItemsList = this.getFilteredItemsList();
    return (
      !!filteredItemsList && (
        <>
          <ProductsGrid
            products={filteredItemsList}
            isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
            productsBlock={[filteredItemsList]}
            labels={labels}
            wishlistsSummaries={wishlistsSummaries}
            createNewWishList={createNewWishList}
            onQuickViewOpenClick={onQuickViewOpenClick}
            isFavoriteView
            removeFavItem={setLastDeletedItemId}
            createNewWishListMoveItem={createNewWishListMoveItem}
            isKeepAliveEnabled={isKeepAliveEnabled}
            outOfStockLabels={outOfStockLabels}
            openAddNewList={this.handleAddList}
            activeWishListId={activeWishList.id}
            onSeeSuggestedItems={this.onSeeSuggestedItems}
            onCloseSuggestedModal={this.onCloseSuggestedModal}
            seeSuggestedDictionary={seeSuggestedDictionary}
            addToBagEcom={addToBagEcom}
            favoriteErrorMessages={errorMessages}
            currencyAttributes={currencyAttributes}
            isLoggedIn={isLoggedIn}
            cookieToken={cookieToken}
            isShowPriceRangeKillSwitch={isShowPriceRangeKillSwitch}
            showPriceRangeForABTest={showPriceRangeForABTest}
            suggestedProductErrors={suggestedProductErrors}
            hasSuggestedProduct={hasSuggestedProduct}
            isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
            isInfluencerPicksEnabled={isInfluencerPicksEnabled}
            isGuestFav={isGuestFav}
            isGuestFavWeb={isGuestFavWeb}
            isFavPage
            useRouterNavigation
          />
        </>
      )
    );
  };

  brandFilterList = () => {
    const { selectBrandType, gymSelected, tcpSelected, snjSelected, pjpSelected, availableBrands } =
      this.props;

    const brandOptions = [
      {
        name: 'tcpOption',
        dataLocator: 'tcp-option',
        brandLabel: renderLabel(this.globalGenericLabels[lblTcp], lblTcp),
        checked: tcpSelected,
      },
      {
        name: 'gymboreeOption',
        dataLocator: 'gymboree-option',
        brandLabel: renderLabel(this.globalGenericLabels[lblGym], lblGym),
        checked: gymSelected,
      },
      {
        name: 'snjOption',
        dataLocator: 'snj-option',
        brandLabel: renderLabel(this.favLabels[lblFavSnj], lblFavSnj),
        checked: snjSelected,
      },
      {
        name: 'pjpOption',
        dataLocator: 'pjp-option',
        brandLabel: renderLabel(this.favLabels[lblFavPjp], lblFavPjp),
        checked: pjpSelected,
      },
    ];
    if (availableBrands.filter(String).length < 2) {
      return null;
    }
    return (
      <>
        <div>
          <div className="brand-option-list">
            <li className="brand-options is-label">
              {renderLabel(this.favLabels[lblFavBrand], lblFavBrand)}
            </li>
            <div className="brand-option-parent">
              {availableBrands.map((item, i) =>
                item && item !== '' ? (
                  <div className="brand-options" key={brandOptions[i].name}>
                    <InputCheckBox
                      execOnChangeByDefault={false}
                      dataLocator={brandOptions[i].dataLocator}
                      input={{
                        value: brandOptions[i].checked,
                        onChange: selectBrandType,
                        name: brandOptions[i].name,
                      }}
                    >
                      {brandOptions[i].brandLabel}
                    </InputCheckBox>
                  </div>
                ) : null
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  handleAddList = (itemId) => {
    this.currentPopupName = 'addList';
    if (itemId) {
      this.setState({
        isOpenModal: true,
        itemToMove: itemId,
        addListFromMoveOption: true,
      });
    } else {
      this.setState({
        isOpenModal: true,
      });
    }
  };

  handleEditList = () => {
    setTimeout(() => {
      this.currentPopupName = 'editList';
      this.setState({
        isOpenModal: true,
      });
    }, 0);
  };

  handleShareList = (lbl) => {
    this.currentPopupName = 'shareList';
    this.setState({
      isOpenModal: true,
      selectedShareOption: lbl,
    });
  };

  handleCopyLink = (lbl) => {
    this.currentPopupName = 'copyLink';
    this.setState({
      isOpenModal: true,
      selectedShareOption: lbl,
    });
  };

  onCloseModal = (moveItem) => {
    if (moveItem) {
      this.setState({
        isOpenModal: false,
        itemToMove: '',
        addListFromMoveOption: false,
        selectedShareOption: renderLabel(this.favLabels[lblFavShare], lblFavShare),
      });
    } else {
      this.setState({
        isOpenModal: false,
        selectedShareOption: renderLabel(this.favLabels[lblFavShare], lblFavShare),
      });
    }
  };

  getCurrentPopUpHeading = () => {
    if (this.currentPopupName === 'addList') {
      return renderLabel(
        this.favLabels[lblFavCreateNewListHeading],
        'lbl_fav_create_new_list_heading'
      );
    }
    if (this.currentPopupName === 'shareList' || this.currentPopupName === 'copyLink') {
      return renderLabel(this.favLabels[lblFavShareListHeading], 'lbl_fav_share_list_heading');
    }

    return '';
  };

  onAddNewListHandler = (data) => {
    const { createNewWishList, createNewWishListMoveItem } = this.props;
    const { addListFromMoveOption } = this.state;
    const payload = {
      wishListName: data.listName,
      isDefault: data.makeDefaultList,
      itemId: data.itemId,
    };
    if (addListFromMoveOption) {
      createNewWishListMoveItem(payload);
      this.onCloseModal(true);
    } else {
      createNewWishList(payload);
      this.onCloseModal(false);
    }
  };

  onEditListHandler = (data) => {
    const { updateWishList, activeWishListId } = this.props;
    this.onCloseModal();
    if (updateWishList) {
      const payload = {
        wishlistId: activeWishListId,
        wishlistName: data.listName,
        setAsDefault: data.makeDefaultList,
      };
      updateWishList(payload);
    }
  };

  onDeleteListHandler = () => {
    const { deleteWishList } = this.props;
    this.onCloseModal();
    if (deleteWishList) {
      deleteWishList();
    }
  };

  onDeleteOOSFromListHandler = (OOSItems) => {
    const { deleteWishListOOS } = this.props;
    this.onCloseModal();
    if (deleteWishListOOS && OOSItems) {
      deleteWishListOOS();
    }
  };

  onShareListSubmit = (data) => {
    const { sendWishListEmail } = this.props;
    this.setState({
      selectedShareOption: renderLabel(this.favLabels[lblFavShare], lblFavShare),
    });
    const payload = {
      shareToEmailAddresses: data.toEmail,
      shareFromEmailAddresses: data.fromEmail,
      shareSubject: data.subject,
      shareMessage: data.message,
    };
    sendWishListEmail(payload);
  };

  renderModalWrapper = () => {
    const { isOpenModal } = this.state;
    return (
      <ModalWrapper
        heading={this.getCurrentPopUpHeading()}
        modalMargins="0 14px 0 14px"
        isOpenModal={isOpenModal}
        onCloseModal={this.onCloseModal}
        widthConfig={{ small: '375px', medium: '432px', large: '432px' }}
        heightConfig={{ height: 'auto' }}
        standardHeight
      >
        {this.getCurrentPopUp()}
      </ModalWrapper>
    );
  };

  onDropdownChange = (id, name) => {
    const { getActiveWishlist, resetBrandFilters } = this.props;
    getActiveWishlist(id, name);
    if (resetBrandFilters) {
      resetBrandFilters();
    }
  };

  getCurrentPopUp = () => {
    const { userEmail, activeWishListId, activeWishList, wishlistsSummaries } = this.props;
    const { itemToMove } = this.state;
    if (this.currentPopupName === 'addList') {
      return (
        <AddList
          onSubmit={this.onAddNewListHandler}
          onCloseModal={this.onCloseModal}
          initialValues={{
            itemId: itemToMove,
          }}
        />
      );
    }
    if (this.currentPopupName === 'editList') {
      const isCheckBoxDisabled = (wishlistsSummaries && wishlistsSummaries.length === 1) || false;
      return (
        <EditList
          onSubmit={this.onEditListHandler}
          onCloseModal={this.onCloseModal}
          activeWishListId={activeWishListId}
          onDeleteList={this.onDeleteListHandler}
          initialValues={{
            listName: activeWishList?.displayName,
            makeDefaultList: activeWishList?.isDefault,
          }}
          isCheckBoxDisabled={isCheckBoxDisabled}
        />
      );
    }
    if (this.currentPopupName === 'shareList') {
      return (
        <ShareList
          onSubmit={this.onShareListSubmit}
          onCloseModal={this.onCloseModal}
          initialValues={{
            subject: renderLabel(this.favLabels[lblFavSubjectDefault], 'lbl_fav_subject_default'),
            fromEmail: userEmail,
          }}
        />
      );
    }
    if (this.currentPopupName === 'copyLink') {
      return (
        <CopyLink
          onHandloneSubmit={this.onEditListHandler}
          onCloseModal={this.onCloseModal}
          shareableLink={this.getSharableLink()}
        />
      );
    }
    return null;
  };

  getFavoriteItemCount = (filteredList) => {
    if (filteredList && filteredList.length) {
      return filteredList.length;
    }
    return 0;
  };

  handleRemoveLinkClick = (e) => {
    e.preventDefault();
    this.onDeleteListHandler();
  };

  handleRemoveLinkClickOOS = (e) => {
    e.preventDefault();
    this.onDeleteOOSFromListHandler(true);
    this.setFavOOSShownState(true);
  };

  onCloseIconClick = (e) => {
    e.preventDefault();
    this.setFavOOSShownState(true);
  };

  renderFavOOSMessage = (isGuestFav) => {
    const { activeWishList } = this.props;
    const { isRemoveOOSFavShown } = this.state;
    const hasOOSItems = activeWishList?.items?.some(
      (item) => item?.itemInfo?.availability !== 'OK'
    );
    return !isRemoveOOSFavShown && hasOOSItems && !isGuestFav ? (
      <BodyCopy className="remove-favorite-oos-container" component="div">
        <Image
          alt="Warning"
          className="favorite-warning-icon"
          src={getIconPath('circle-warning-fill')}
          data-locator="favorite-warning-icon"
        />
        <BodyCopy
          fontWeight="normal"
          color="gray.900"
          fontFamily="secondary"
          className="favorite-remove-now"
          dataLocator={getLocator('favorite-remove')}
        >
          {renderLabel(this.favLabels[lblFavOosMessage], lblFavOosMessage)}
          <Anchor
            underline
            noLink
            dataLocator="fav-remove-link"
            onClick={this.handleRemoveLinkClickOOS}
          >
            {renderLabel(this.favLabels[lblFavOosRemove], lblFavOosRemove)}
          </Anchor>
        </BodyCopy>
        <Anchor id="close-image" noLink onClick={this.onCloseIconClick} data-locator="close-icon">
          <Image
            alt="Close"
            className="favorite-close-icon"
            src={getIconPath('cross-icon')}
            data-locator="favorite-close-icon"
          />
        </Anchor>
      </BodyCopy>
    ) : null;
  };

  getLabel = (guestAccessKey, activeDisplayName, myFavLabel) => {
    return guestAccessKey ? activeDisplayName : myFavLabel;
  };

  guestActiveWishlistcheck = (isGuestFav, isActiveListHaveLength) =>
    isGuestFav && isActiveListHaveLength;

  activeWishlistLengthCheck = (isActiveListHaveLength) =>
    isActiveListHaveLength && isActiveListHaveLength !== null;

  extractLabel = (isGuestFav, guestAccessKey, activeDisplayName, myFavLabel) => {
    return isGuestFav
      ? spcTitleCase(this.getLabel(guestAccessKey, activeDisplayName, myFavLabel))
      : this.getLabel(guestAccessKey, activeDisplayName, myFavLabel);
  };

  render() {
    const labels = { ...this.favLabels, ...this.globalAccessibilityLabels };
    const {
      className,
      wishlistsSummaries,
      activeWishList,
      createNewWishList,
      onFilterSelection,
      onSortSelection,
      defaultWishList,
      isDataLoading,
      guestAccessKey,
      activeDisplayName,
      appliedFilterLength,
      filteredId,
      isGuestFav,
    } = this.props;
    if (isDataLoading) {
      return (
        <>
          <FavoriteSkeleton col={8} />
        </>
      );
    }

    const { selectedShareOption } = this.state;

    const shareOptions = [
      {
        title: renderLabel(this.favLabels[lblFavFacebook], lblFavFacebook),
        value: renderLabel(this.favLabels[lblFavFacebook], lblFavFacebook),
        content: <span>{renderLabel(this.favLabels[lblFavFacebook], lblFavFacebook)}</span>,
      },
      {
        title: renderLabel(this.favLabels[lblFavEmail], lblFavEmail),
        value: renderLabel(this.favLabels[lblFavEmail], lblFavEmail),
        content: <span>{renderLabel(this.favLabels[lblFavEmail], lblFavEmail)}</span>,
      },
      {
        title: renderLabel(this.favLabels[lblFavCopyLink], lblFavCopyLink),
        value: renderLabel(this.favLabels[lblFavCopyLink], lblFavCopyLink),
        content: <span>{renderLabel(this.favLabels[lblFavCopyLink], lblFavCopyLink)}</span>,
      },
    ];
    const filters = activeWishList ? getNonEmptyFiltersList(activeWishList.items, labels) : [];

    const isActiveListHaveLength = activeWishList && activeWishList?.items?.length !== 0;

    const recommendationAttributes = {
      variations: 'moduleO',
      showLoyaltyPromotionMessage: false,
      isFavoriteRecommendation: true,
    };

    const filteredItemsList = this.getFilteredItemsList();
    const itemCount = this.getFavoriteItemCount(filteredItemsList);
    const myFavLabel = renderLabel(this.favLabels[lblFavMyFavorites], lblFavMyFavorites);
    return (
      <div className={`${className} ${guestAccessKey ? 'spacing' : ''}`}>
        {this.renderModalWrapper()}
        {isGuestFav && <GuestFavoritesMessage />}
        <Row fullBleed className="heading-wrapper">
          {!isGuestFav && (
            <BodyCopy component="div" className="elem-mb-MED account-dashboard-goback-link">
              <Anchor
                fontSizeVariation="xlarge"
                anchorVariation="secondary"
                to="/account?id=account-overview"
                asPath="/account"
              >
                <span className="left-arrow" />
                {renderLabel(this.globalActionLabels[lblBack], 'lbl_back')}
              </Anchor>
            </BodyCopy>
          )}
          <Col
            colSize={{ small: 6, medium: 8, large: 12 }}
            ignoreGutter={{ small: true, medium: true, large: true }}
          >
            <BodyCopy
              fontWeight="extrabold"
              fontSize="fs16"
              fontFamily="secondary"
              className={!isGuestFav ? 'favorite-title' : 'favorite-title-new'}
              dataLocator={getLocator('fav_heading')}
            >
              {this.extractLabel(isGuestFav, guestAccessKey, activeDisplayName, myFavLabel)}
              {isGuestFav && <span className={'secondary-title'}>{'DEFAULT'}</span>}
            </BodyCopy>
          </Col>
          {this.guestActiveWishlistcheck(isGuestFav, isActiveListHaveLength) && (
            <Col
              colSize={{ small: 6, medium: 8, large: 12 }}
              ignoreGutter={{ small: true, medium: true, large: true }}
              className={'prod-count'}
            >
              <strong className="bold-text">{`${activeWishList?.items?.length}`}</strong>
              {` items`}
            </Col>
          )}
        </Row>
        {!isGuestFav && (
          <Row fullBleed className="list-selection-row">
            <Col colSize={{ small: 6, medium: 6, large: 8 }}>
              <Row fullBleed>
                <Col
                  colSize={{ small: 6, medium: 5, large: 6 }}
                  offsetLeft={{ medium: 3, large: 6 }}
                >
                  <SelectWishListDropdown
                    wishlistsSummaries={wishlistsSummaries}
                    createNewWishList={createNewWishList}
                    getActiveWishlist={this.onDropdownChange}
                    activeWishList={activeWishList}
                    defaultWishList={defaultWishList}
                    openAddNewList={this.handleAddList}
                    openEditList={this.handleEditList}
                    isFavoriteView
                  />
                </Col>
              </Row>
            </Col>
            <Col colSize={{ small: 6, medium: 2, large: 4 }}>
              <Row fullBleed>
                <Col
                  colSize={{ small: 2, medium: 6, large: 4 }}
                  offsetLeft={{ small: 4, medium: 2, large: 8 }}
                >
                  {isActiveListHaveLength && isActiveListHaveLength !== null ? (
                    <CustomSelect
                      options={shareOptions}
                      activeTitle={selectedShareOption}
                      clickHandler={(e, value) => this.shareClickHandler(value)}
                      customSelectClassName="social-share-fav-list"
                    />
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        {this.renderFavOOSMessage(isGuestFav)}
        {this.activeWishlistLengthCheck(isActiveListHaveLength) ? (
          <>
            {!isGuestFav && (
              <>
                <Row fullBleed>
                  <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                    <ProductListingFiltersForm
                      filtersMaps={{
                        display_group_uFilter: filters,
                        unbxdDisplayName: {
                          display_group_uFilter: filters.length && filters[0].displayName,
                        },
                      }}
                      totalProductsCount={itemCount}
                      initialValues={{}}
                      filtersLength={{}}
                      labels={labels}
                      isFavoriteView
                      favoriteSortingParams={getSortsList(this.favLabels)}
                      onFilterSelection={onFilterSelection}
                      onSortSelection={onSortSelection}
                      defaultPlaceholder={getSortsList(this.favLabels)[0].displayName}
                      appliedFilterLength={appliedFilterLength}
                      filteredId={filteredId}
                    />
                  </Col>

                  <Col colSize={{ small: 6, medium: 8, large: 12 }} className="show-count-section">
                    <LoadedProductsCount totalProductsCount={itemCount} isFavoriteView />
                  </Col>
                </Row>

                <Row className="brand-filter-section" fullBleed>
                  <Col colSize={{ large: 12, medium: 8, small: 6 }}>{this.brandFilterList()}</Col>
                </Row>
              </>
            )}
            <Row fullBleed>
              <Col
                colSize={{ small: 6, medium: 8, large: 12 }}
                className="product-list"
                ignoreGutter={{ small: true, medium: true, large: true }}
              >
                {this.renderProductList()}
              </Col>
            </Row>
          </>
        ) : (
          <Row fullBleed>
            <NoFavoritesFound />
            <Col
              hideCol={{ small: true, medium: true }}
              colSize={{ small: 6, medium: 8, large: 12 }}
              className="recommendation"
            >
              {' '}
              <div>
                <Recommendations
                  page={Constants.RECOMMENDATIONS_PAGES_MAPPING.NO_FAVORITES}
                  variations="moduleO"
                  portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
                  {...recommendationAttributes}
                  sequence="1"
                />
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

FavoritesView.propTypes = {
  className: PropTypes.string.isRequired,
  wishlistsSummaries: PropTypes.arrayOf({}),
  activeWishList: PropTypes.shape({
    items: PropTypes.shape([]),
    id: PropTypes.string,
    displayName: PropTypes.string,
    isDefault: PropTypes.bool,
  }),
  createNewWishListMoveItem: PropTypes.func.isRequired,
  deleteWishList: PropTypes.func.isRequired,
  deleteWishListOOS: PropTypes.func.isRequired,
  createNewWishList: PropTypes.func.isRequired,
  getActiveWishlist: PropTypes.func.isRequired,
  setLastDeletedItemId: PropTypes.func.isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  filteredId: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
  onFilterSelection: PropTypes.func.isRequired,
  onSortSelection: PropTypes.func.isRequired,
  selectBrandType: PropTypes.string.isRequired,
  gymSelected: PropTypes.bool.isRequired,
  tcpSelected: PropTypes.bool.isRequired,
  snjSelected: PropTypes.bool.isRequired,
  isKeepAliveEnabled: PropTypes.bool.isRequired,
  defaultWishList: PropTypes.shape({}),
  userEmail: PropTypes.string.isRequired,
  sendWishListEmail: PropTypes.func.isRequired,
  wishlistShareStatus: PropTypes.bool,
  setListShareSuccess: PropTypes.func,
  addToBagEcom: PropTypes.func.isRequired,
  appliedFilterLength: PropTypes.number,
  isBothTcpAndGymProductAreAvailable: PropTypes.bool,
  availableBrands: PropTypes.arrayOf(''),
  isDataLoading: PropTypes.bool,
  guestAccessKey: PropTypes.string,
  activeDisplayName: PropTypes.string,
  activeWishListId: PropTypes.string,
  updateWishList: PropTypes.func,
  resetBrandFilters: PropTypes.func,
  onReplaceWishlistItem: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}),
  errorMessages: PropTypes.shape({}).isRequired,
  currencyAttributes: PropTypes.shape({}),
  trackPageLoad: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  cookieToken: PropTypes.string,
  isShowPriceRangeKillSwitch: PropTypes.bool.isRequired,
  showPriceRangeForABTest: PropTypes.bool.isRequired,
  suggestedProductErrors: PropTypes.shape({}).isRequired,
  hasSuggestedProduct: PropTypes.bool.isRequired,
  setSuggestedColorProductId: PropTypes.func,
  isCrossBrandMerchandisingEnabled: PropTypes.bool,
  isInfluencerPicksEnabled: PropTypes.bool,
  isGuestFav: PropTypes.bool,
};

FavoritesView.defaultProps = {
  wishlistsSummaries: [],
  activeWishList: {},
  defaultWishList: {},
  wishlistShareStatus: false,
  setListShareSuccess: () => {},
  appliedFilterLength: 0,
  updateWishList: () => {},
  isBothTcpAndGymProductAreAvailable: false,
  availableBrands: [],
  isDataLoading: true,
  guestAccessKey: '',
  activeDisplayName: '',
  resetBrandFilters: () => {},
  activeWishListId: '',
  navigation: {},
  currencyAttributes: {},
  trackPageLoad: () => {},
  setSuggestedColorProductId: () => {},
  isLoggedIn: false,
  cookieToken: null,
  isCrossBrandMerchandisingEnabled: false,
  isInfluencerPicksEnabled: false,
  isGuestFav: false,
};

export default withStyles(FavoritesView, FavoritesViewStyle);
